import { AxiosGlobalFilters } from '../config';
import { CreateUsuarioCommand, SavePermissoesUsuarioCommand } from './UsuariosService.types';

export * from './UsuariosService.types';

// API Lighthouse de usuários (branch API-de-Usuarios).
// EmpresaId/UnidadeId sempre em HEADER — nunca no body ([JsonIgnore] no back).
export const UsuariosService = {
  createUsuario: ({
    data,
    EmpresaId,
    UnidadeId,
  }: {
    data: CreateUsuarioCommand;
    EmpresaId: number;
    UnidadeId?: number;
  }) => {
    const headers: Record<string, string | number> = { 'content-type': 'application/json', EmpresaId };
    // UnidadeId opcional: quando enviado, o POST já cria a linha de permissão daquela unidade (tipo 3/4).
    if (UnidadeId !== undefined) headers.UnidadeId = UnidadeId;
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/usuarios',
      data,
      headers,
    });
  },
  savePermissoesUsuario: ({ data, EmpresaId }: { data: SavePermissoesUsuarioCommand; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'put',
      url: '/v1/usuarios/permissoes',
      data,
      headers: { 'content-type': 'application/json', EmpresaId },
    });
  },
  getPermissoesCatalogo: ({ tipoUsuarioAlvo, EmpresaId }: { tipoUsuarioAlvo?: number; EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/permissoes',
      params: { tipoUsuarioAlvo },
      headers: { EmpresaId },
    });
  },
  getUnidadesAtivas: ({ EmpresaId }: { EmpresaId: number }) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v2/unidades/ativas',
      headers: { EmpresaId },
    });
  },
};
